module.exports = __webpack_public_path__ + "static/img/名錄.png";